module.exports = __webpack_public_path__ + "components/flag/static/square/at-1c9b88193fbc62920afcfc9ff158130b.svg";